module.exports = __webpack_public_path__ + "static/img/41-100.3bb62d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-slider/41-100.jpg
// module id = ZEFF
// module chunks = 2